import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import MainPage from "../pages/MainPage";
import ResponsiveNavBar from "../NavBar/index";
import AppFooter from "../AppFooter";
import { Paper, Stack, Box, Typography } from "@mui/material";
import OrderDetails from "../pages/OrderDetails";
import { useContext } from "react";
import { ConfigLinksDetailsContext } from "../Context/cofingLinksDetailsContext";
import { UserDetailsContext } from "../Context/userDetailsContext";
import RequestService from "../pages/RequestService";
import ForgetPassword from "../pages/ForgetPassword";
import CheckCode from "../pages/CheckCode";
import ResetPassword from "../pages/ResetPassword";
import ProtectedRoute from "./ProtectedRoute";
import RedirectToHomeIfAuthenticated from "./RedirectToHomeIfAuthenticated";
import BreadCrumb from "../Components/BreadCrumb";
import ServiceOrder from "../Components/ServiceOrder";
import ServicesGuide from "../pages/ServicesGuide";
import ServiceGuideDetails from "../pages/ServiceGuideDetails";
import Signup from "../pages/Signup";
import SignUpCompany from "../pages/SignUpCompany";
import MyAccount from "../pages/MyAccount";
import MyOrders from "../pages/MyOrders";
import MyNotifications from "../pages/MyNotifications";
import MyServices from "../pages/MyServices";
import TermsAndConditions from "../pages/TermsAndConditions";
import PrivacyAndProtection from "../pages/PrivacyAndProtection";
import RatePortal from "../pages/RatePortal";
import ContactUs from "../pages/ContactUs";
import { ChatbotButton } from "../Components/Chatbot";
import GuestPortal from "../pages/GuestPortal";
import GuestServices from "../pages/GuestServices";
import GuestTrackRequest from "../pages/GuestTrackRequest";
import GuestRequest from "../pages/GuestRequest";
import GuestOrderDetails from "../pages/GuestOrderDetails";
import NotFound from "../pages/NotFound";
import News from "../pages/News";
import NewsDetails from "../pages/NewsDetails";
import HelpCenter from "../pages/HelpCenter";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../appInsights';

// Define the tracked components
const MainPageWithTracking = withAITracking(reactPlugin, MainPage);
const OrderDetailsWithTracking = withAITracking(reactPlugin, OrderDetails);
const RequestServiceWithTracking = withAITracking(reactPlugin, RequestService);
const ServiceOrderWithTracking = withAITracking(reactPlugin, ServiceOrder);
const MyAccountWithTracking = withAITracking(reactPlugin, MyAccount);
const MyOrdersWithTracking = withAITracking(reactPlugin, MyOrders);
const MyNotificationsWithTracking = withAITracking(reactPlugin, MyNotifications);
const MyServicesWithTracking = withAITracking(reactPlugin, MyServices);
const ServicesGuideWithTracking = withAITracking(reactPlugin, ServicesGuide);
const ServiceGuideDetailsWithTracking = withAITracking(reactPlugin, ServiceGuideDetails);
const LoginWithTracking = withAITracking(reactPlugin, Login);
const ForgetPasswordWithTracking = withAITracking(reactPlugin, ForgetPassword);
const CheckCodeWithTracking = withAITracking(reactPlugin, CheckCode);
const ResetPasswordWithTracking = withAITracking(reactPlugin, ResetPassword);
const SignupWithTracking = withAITracking(reactPlugin, Signup);
const SignUpCompanyWithTracking = withAITracking(reactPlugin, SignUpCompany);
const TermsAndConditionsWithTracking = withAITracking(reactPlugin, TermsAndConditions);
const PrivacyAndProtectionWithTracking = withAITracking(reactPlugin, PrivacyAndProtection);
const RatePortalWithTracking = withAITracking(reactPlugin, RatePortal);
const ContactUsWithTracking = withAITracking(reactPlugin, ContactUs);
const GuestPortalWithTracking = withAITracking(reactPlugin, GuestPortal);
const GuestServicesWithTracking = withAITracking(reactPlugin, GuestServices);
const GuestTrackRequestWithTracking = withAITracking(reactPlugin, GuestTrackRequest);
const GuestRequestWithTracking = withAITracking(reactPlugin, GuestRequest);
const NewsWithTracking = withAITracking(reactPlugin, News);
const NewsDetailsWithTracking = withAITracking(reactPlugin, NewsDetails);
const HelpCenterWithTracking = withAITracking(reactPlugin, HelpCenter);

const AppRoutes = () => {
  const { configLinks } = useContext(ConfigLinksDetailsContext);
  const { userDetails } = useContext(UserDetailsContext);

  return (
    <Router>
      <Stack sx={{ gap: { xs: 1, md: 3 }, minHeight: '100vh', display: 'flex', flexDirection: 'column', flex: 1 }}>
        <ResponsiveNavBar />
        <BreadCrumb sx={{ borderRadius: "24px" }} />
        <Paper sx={{ backgroundColor: "#F9FAFC", flex: 1, display: 'flex', flexDirection: 'column' }}  elevation={2}>
          <Routes>
            <Route
              path="/"
              element={userDetails?.isAuthenticated ? <MainPageWithTracking /> : <GuestPortalWithTracking />}
            />
            <Route
              path="/home"
              element={<Navigate to="/" replace />}
            />
            <Route
              path="/order-details/:id"
              element={
                <ProtectedRoute>
                  <OrderDetailsWithTracking />
                </ProtectedRoute>
              }
            />
  
            <Route
              path="/service-request"
              element={
                <ProtectedRoute>
                  <RequestServiceWithTracking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/services"
              element={
                <ProtectedRoute>
                  <ServiceOrderWithTracking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-account"
              element={
                <ProtectedRoute>
                  <MyAccountWithTracking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-orders/:status"
              element={
                <ProtectedRoute>
                  <MyOrdersWithTracking />
                </ProtectedRoute>
              }
            />
                        <Route
              path="/my-orders/"
              element={
                <ProtectedRoute>
                  <MyOrdersWithTracking />
                  </ProtectedRoute>
              }
              />
            <Route
              path="/my-notifications"
              element={
                <ProtectedRoute>
                  <MyNotificationsWithTracking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-services"
              element={
                <ProtectedRoute>
                  <MyServicesWithTracking />
                </ProtectedRoute>
              }
            />
            <Route path="/services-guide" element={<ServicesGuideWithTracking />} />
            <Route path="/service-guide-details" element={<ServiceGuideDetailsWithTracking />} />
            <Route
              path="/login"
              element={
                <RedirectToHomeIfAuthenticated>
                  <LoginWithTracking />
                </RedirectToHomeIfAuthenticated>
              }
            />
            <Route
              path="/forget-password"
              element={
                <RedirectToHomeIfAuthenticated>
                  <ForgetPasswordWithTracking />
                </RedirectToHomeIfAuthenticated>
              }
            />
            <Route
              path="/code-check/:userId"
              element={
                <RedirectToHomeIfAuthenticated>
                  <CheckCodeWithTracking />
                </RedirectToHomeIfAuthenticated>
              }
            />
            <Route
              path="/reset-password/:userId/:code"
              element={
                <RedirectToHomeIfAuthenticated>
                  <ResetPasswordWithTracking />
                </RedirectToHomeIfAuthenticated>
              }
            />
            <Route path="sign-up" element={<SignupWithTracking />} />
            <Route path="sign-up-company" element={<SignUpCompanyWithTracking />} />
            <Route path="terms-and-conditions" element={<TermsAndConditionsWithTracking />} />
            <Route path="privacy-and-protection" element={<PrivacyAndProtectionWithTracking />} />
            <Route
              path="/rate-portal"
              element={
                <ProtectedRoute>
                  <RatePortalWithTracking />
                </ProtectedRoute>
              }
            />
            <Route path="/contact-us" element={<ContactUsWithTracking />} />
            <Route path="/news" element={<NewsWithTracking />} />
            <Route path="/news/:id" element={<NewsDetailsWithTracking />} />
            <Route path="/help" element={<HelpCenterWithTracking />} />
            <Route path="/guest" element={<GuestPortalWithTracking />} />
            <Route path="/guest-services" element={<GuestServicesWithTracking />} />
            <Route path="/guest-track-request" element={<GuestTrackRequestWithTracking />} />
            <Route path="/guest-request" element={<GuestRequestWithTracking />} />
            <Route path="/guest/order-details" element={<GuestOrderDetails />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Paper>
        <AppFooter />
      </Stack>
      {configLinks?.chatbotEnabled && <ChatbotButton />}
    </Router>
  );
};

export default AppRoutes;
